"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
interface MemeDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
export default function MemeDropArtistInfo(t0) {
  const $ = _c(47);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.level) {
    t2 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author.level;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/${drop.author?.handle}`;
  let t4;
  if ($[4] !== drop.author.handle || $[5] !== drop.author.id) {
    t4 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span></UserProfileTooltipWrapper> : <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span>;
    $[4] = drop.author.handle;
    $[5] = drop.author.id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Link href={t3} onClick={_temp} className="tw-no-underline">{t4}</Link>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop.id || $[11] !== handleBadgeClick || $[12] !== isWinner || $[13] !== winnerCount) {
    t6 = isWinner && <ProfileWinnerBadge winCount={winnerCount} onBadgeClick={() => handleBadgeClick("winners")} tooltipId={`meme-winner-badge-${drop.id}`} />;
    $[10] = drop.id;
    $[11] = handleBadgeClick;
    $[12] = isWinner;
    $[13] = winnerCount;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== drop.id || $[16] !== handleBadgeClick || $[17] !== hasSubmissions || $[18] !== submissionCount) {
    t7 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={() => handleBadgeClick("active")} tooltipId={`meme-badge-${drop.id}`} />;
    $[15] = drop.id;
    $[16] = handleBadgeClick;
    $[17] = hasSubmissions;
    $[18] = submissionCount;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== drop.created_at) {
    t9 = <WaveDropTime timestamp={drop.created_at} />;
    $[21] = drop.created_at;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = drop.winning_context?.decision_time ?? null;
  let t11;
  if ($[23] !== drop.rank || $[24] !== t10) {
    t11 = <div className="tw-ml-2"><WinnerDropBadge rank={drop.rank} decisionTime={t10} /></div>;
    $[23] = drop.rank;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t2 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t5}{t6}{t7}{t8}{t9}{t11}</div>;
    $[26] = t11;
    $[27] = t2;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== drop.wave) {
    t13 = drop.wave && <Link onClick={_temp2} href={`/waves?wave=${drop.wave.id}`} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[33] = drop.wave;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t12 || $[36] !== t13) {
    t14 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t12}{t13}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== drop.author || $[39] !== handleModalClose || $[40] !== isModalOpen || $[41] !== modalInitialTab) {
    t15 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[38] = drop.author;
    $[39] = handleModalClose;
    $[40] = isModalOpen;
    $[41] = modalInitialTab;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t1 || $[44] !== t14 || $[45] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-3">{t1}{t14}{t15}</div>;
    $[43] = t1;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  return t16;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}